import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

interface Props {
  product: {
    state: string
  }
}

const Object360Product = ({product}: Props) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

Object360Product.fragment = gql`
  fragment Object360Product on Object360Product {
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url}
        }
      }
    }
  }
`

export default Object360Product
